<div class="topbar-container">
  <div class="left-section">
    <button
      class="menu-btn"
      (click)="onMenuClick()"
      aria-label="Toggle menu">
      <i class="fa fa-bars"></i>
    </button>
    <app-logo [showIcon]="false"></app-logo>
  </div>
  <div class="right-section">
    <app-theme-toggle></app-theme-toggle>

    <!-- Language Selector -->
    <div class="dropdown language-dropdown" (click)="toggleLanguageMenu()">
      <div class="dropdown-trigger">
        <i class="fa fa-solid fa-globe"></i>
        <span class="lang-label">{{ currentLanguageCode().toUpperCase() }}</span>
      </div>

      @if (isLanguageMenuOpen) {
        <div class="dropdown-menu">
          @for (language of getSupportedLanguages(); track language.code) {
            <div
              class="dropdown-item"
              (click)="changeLanguage(language.code)"
            >
              {{ language.label }}
            </div>
          }
        </div>
      }
    </div>

    <!-- Profile Dropdown -->
    <div class="dropdown profile-dropdown" (click)="toggleProfileMenu()">
      <div class="dropdown-trigger profile-trigger">
        <img
          [src]="'assets/images/user-default-avatar.png'"
          alt="Profile"
          class="profile-pic"
        />
      </div>

      @if (isProfileMenuOpen) {
        <div class="dropdown-menu">
          <div class="dropdown-item" (click)="navigateToProfile()">Profile</div>
          <div class="dropdown-item" (click)="logout()">Logout</div>
        </div>
      }
    </div>
  </div>
</div>
